if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        window.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");

        const spinner = opener.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

            // Re-initialize bundle script inside modal
            this.initBundles();

            // Shopify and XR initialization
            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            if (spinner) spinner.classList.add("hidden");
          });
      }

      setInnerHTML(element, html, opener) {
        element.innerHTML = html;

        // Reinject script tags
        element.querySelectorAll("script").forEach((oldScript) => {
          const newScript = document.createElement("script");
          Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      initBundles() {
        const bundleBlocks = Array.from(this.modalContent.querySelectorAll(".bundle-item-block"));
        if (!bundleBlocks.length) return;

        const mainSelect = this.modalContent.querySelector('select[name="id"], select.select__select');
        const variantInput = this.modalContent.querySelector("#bundle-selected-variant");
        const quantityInput = this.modalContent.querySelector("#bundle-selected-quantity");
        const addToCartButton = this.modalContent.querySelector(".product-form__submit");
        const priceBundleDiv = this.modalContent.querySelector("#price-bundle");

        function formatPriceFromEuros(euros) {
          return euros.toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
        }

        function getSelectedVariantInfo(select) {
          if (!select) return { id: null, priceCents: 0 };
          const opt = select.selectedOptions[0];
          return opt ? { id: opt.value, priceCents: parseInt(opt.dataset.price || 0) } : { id: null, priceCents: 0 };
        }

        function updateMainSelectVariant(variantId) {
          if (!mainSelect || !variantId) return;
          mainSelect.value = variantId;
          ["change", "input"].forEach(eventName => mainSelect.dispatchEvent(new Event(eventName, { bubbles: true })));
        }

        function updateAddToCartPrice(finalPriceCents, originalPriceCents, discount) {
          if (!addToCartButton) return;
          const span = addToCartButton.querySelector("span");
          if (!span) return;
          const original = span.dataset.originalText || span.textContent.trim();
          span.dataset.originalText = original;
          const finalPriceHtml = formatPriceFromEuros(finalPriceCents / 100);
          let html = `${original} <span class="bundle-price-final">- ${finalPriceHtml}</span>`;
          if (discount > 0) {
            const originalPriceHtml = formatPriceFromEuros(originalPriceCents / 100);
            html += ` <span class="bundle-price-details">- ${originalPriceHtml}</span>`;
          }
          span.innerHTML = html;
        }

        function updateSubscriptionPrices(newPriceCents) {
          const subscriptionApp = document.querySelector(".shopify_subscriptions_app_container, .shopify_subscriptions_app_block");
          if (!subscriptionApp) return;
          const newPrice = (newPriceCents / 100).toFixed(2).replace(".", ",") + "€";
          const oneTimePriceEl = subscriptionApp.querySelector(".shopify_subscriptions_in_widget_price");
          if (oneTimePriceEl) oneTimePriceEl.textContent = newPrice;
        }

        function updateBundleBlock(block) {
          const label = block.querySelector(".bundle-option-label");
          const radio = label.querySelector('input[type="radio"]');
          const select = block.querySelector(".bundle-inner-select");
          const quantity = parseInt(label.dataset.quantity || 1);
          const discount = parseFloat(label.dataset.discount || 0);
          const { id: variantId, priceCents } = getSelectedVariantInfo(select);

          const totalOriginalCents = priceCents * quantity;
          const discountedUnit = priceCents * (1 - discount / 100);
          const totalFinalCents = Math.round(discountedUnit * quantity);

          const priceWrapper = block.querySelector(".bundle-price-wrapper");
          if (priceWrapper) {
            const finalPriceEl = priceWrapper.querySelector(".bundle-price-final");
            const detailsEl = priceWrapper.querySelector(".bundle-price-details");
            if (finalPriceEl) finalPriceEl.textContent = formatPriceFromEuros(totalFinalCents / 100);
            if (detailsEl) {
              discount > 0 ? (detailsEl.style.display = "inline", detailsEl.textContent = formatPriceFromEuros(totalOriginalCents / 100)) : (detailsEl.style.display = "none");
            }
          }

          if (priceBundleDiv) {
            priceBundleDiv.innerHTML = `
              <span class="bundle-price-final">${formatPriceFromEuros(totalFinalCents / 100)}</span>
              ${discount > 0 ? `<span class="bundle-price-details">${formatPriceFromEuros(totalOriginalCents / 100)}</span>` : ""}
            `;
          }

          if (radio.checked) {
            bundleBlocks.forEach(b => b.classList.remove("selected"));
            block.classList.add("selected");
            if (variantInput) variantInput.value = variantId;
            if (quantityInput) quantityInput.value = quantity;
            updateMainSelectVariant(variantId);
            updateSubscriptionPrices(priceCents);
            updateAddToCartPrice(totalFinalCents, totalOriginalCents, discount);
          } else {
            block.classList.remove("selected");
          }
        }

        function protectSelectFromLabel(select) {
          if (!select) return;
          select.addEventListener("click", e => e.stopPropagation(), { passive: true });
          select.addEventListener("touchstart", e => e.stopPropagation(), { passive: true });
        }

        // Attach events
        bundleBlocks.forEach(block => {
          const radio = block.querySelector(".bundle-option-label input[type='radio']");
          const select = block.querySelector(".bundle-inner-select");

          protectSelectFromLabel(select);

          if (select) select.addEventListener("change", () => {
            if (radio && !radio.checked) radio.checked = true;
            updateBundleBlock(block);
          });

          if (radio) radio.addEventListener("change", () => {
            if (radio.checked) updateBundleBlock(block);
          });

          // Initial render
          updateBundleBlock(block);
        });
      }
    }
  );
}
